import { ListProps, TextField } from 'react-admin';
import { TextInput, Grid, GridList, Forbidden } from '@components';
import { useRbacList } from '@hooks';

export const CountryList = (props: ListProps) => {
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Grid
        rowClick="edit"
        defaultColumns={['id', 'name', 'capital', 'subregion', 'iso3', 'emoji']}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="Country" />
        <TextField source="phoneCode" label="Phone Code" />
        <TextField source="capital" label="Capital" />
        <TextField source="native" label="Native" />
        <TextField source="region" label="Region" />
        <TextField source="subregion" label="Subregion" />
        <TextField source="iso3" label="Code" />
        <TextField source="emoji" label="Emoji" />
        <TextField source="currency" label="Currency" />
        <TextField source="currencySymbol" label="Currency Symbol" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" label="Search" alwaysOn style={{ width: 220 }} />,
];
